module.exports = __webpack_public_path__ + "static/media/graphIcon.fa494f9a.png";